module.exports = __webpack_public_path__ + "static/media/04.7ec03b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/04.jpg
// module id = 694
// module chunks = 0